module.exports = __webpack_public_path__ + "static/media/female_digestive_system.a775e599.png";